module.exports = "data:application/x-font-ttf;base64,"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/deal-or-no-deal-prizes-server/admin/src/web/src/assets/fonts/moonhouse.ttf
// module id = ../../../../../src/assets/fonts/moonhouse.ttf
// module chunks = styles